'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormTriggers', ['$scope', '$q', 'FBForms', 'Triggers',
        function ($scope, $q, FBForms, Triggers) {
        $scope.resetForm();
        $scope.saving = false;
        $scope.loading = true;

        var promises = [];

        promises.push(Triggers.get().then(function (triggers) {
            $scope.triggers = triggers;
        }));
            
        
        $scope.save = function () {
            $scope.saving = true;
            var all = [];
            
            all.push(FBForms.save({ form: $scope.form, license_id: $scope.licenseID }).then(function (form) {
                if (form != null) {
                    $scope.form = form;
                }
            }));

            $q.all(all).then(function () {
                $scope.saving = false;
            }).catch(function (response) {
                // handle error
            });
            
        }

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

    }])
;